import { render, staticRenderFns } from "./longSentencesCircle.vue?vue&type=template&id=0a7edaff&scoped=true&"
import script from "./longSentencesCircle.vue?vue&type=script&lang=js&"
export * from "./longSentencesCircle.vue?vue&type=script&lang=js&"
import style0 from "./longSentencesCircle.vue?vue&type=style&index=0&id=0a7edaff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7edaff",
  null
  
)

export default component.exports